import _ from 'lodash'

export default class Password {
  static generateMasked(length: number = 8): string {
    return _.fill(new Array(length), '*').join('')
  }
}
